/**
 * Non-breaking space (&nbsp;)
 * @returns a non-breaking space
 */
const NonBreakingSpace = (): JSX.Element => <>{"\u00a0"}</>;

export default NonBreakingSpace;
